import { CredentialsEnum } from './credentials'
import { MenuItemKeys } from './menu-item-keys'
import { PrivateRouteUrls } from './routes-urls'

/**
 * Maps menu items and routes to their required credentials
 * This keeps permissions separate from the menu structure
 *
 * El API solo deja operar el panel al super-admin (validateSuperAdminAccess en
 * auth-hc1-api), así que todas las pantallas piden la misma credencial reservada.
 */
const SUPER_ADMIN = [CredentialsEnum.SYSTEM_FULL_ACCESS]

export const MENU_CREDENTIALS: Record<MenuItemKeys, CredentialsEnum[]> = {
  [MenuItemKeys.USERS]: SUPER_ADMIN,
  [MenuItemKeys.USER_PERMISSIONS]: SUPER_ADMIN,
  [MenuItemKeys.DOMAINS]: SUPER_ADMIN,
  [MenuItemKeys.DOMAIN_VARS]: SUPER_ADMIN,
  [MenuItemKeys.DOMAIN_VAR_VALUES]: SUPER_ADMIN,
  [MenuItemKeys.CLIENTS]: SUPER_ADMIN,
  [MenuItemKeys.ROLES]: SUPER_ADMIN,
  [MenuItemKeys.PERMISSIONS]: SUPER_ADMIN,
  [MenuItemKeys.PERMISSIONS_CATALOGUE]: SUPER_ADMIN,
  [MenuItemKeys.CLIENT_STATUS]: SUPER_ADMIN,
  [MenuItemKeys.DIVIDER]: []
}

export const ROUTE_CREDENTIALS: Record<string, CredentialsEnum[]> = {
  [PrivateRouteUrls.USERS]: SUPER_ADMIN,
  [PrivateRouteUrls.USER_PERMISSIONS]: SUPER_ADMIN,
  [PrivateRouteUrls.DOMAINS]: SUPER_ADMIN,
  [PrivateRouteUrls.DOMAIN_VARS]: SUPER_ADMIN,
  [PrivateRouteUrls.DOMAIN_VAR_VALUES]: SUPER_ADMIN,
  [PrivateRouteUrls.CLIENTS]: SUPER_ADMIN,
  [PrivateRouteUrls.ROLES]: SUPER_ADMIN,
  [PrivateRouteUrls.ROLE_CREDENTIALS]: SUPER_ADMIN,
  [PrivateRouteUrls.CREDENTIALS]: SUPER_ADMIN,
  [PrivateRouteUrls.CLIENT_STATUS]: SUPER_ADMIN
}
